import { render, staticRenderFns } from "./TaskOrderComponent.vue?vue&type=template&id=e06ef88c&scoped=true&"
import script from "./TaskOrderComponent.vue?vue&type=script&lang=js&"
export * from "./TaskOrderComponent.vue?vue&type=script&lang=js&"
import style0 from "./TaskOrderComponent.vue?vue&type=style&index=0&id=e06ef88c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e06ef88c",
  null
  
)

export default component.exports